import React from 'react';

const Header = React.lazy(() => import(/* webpackChunkName: "Header" */ './Header'));

export default function HeaderLazy(props: React.ComponentProps<typeof Header>) {
    return (
        <React.Suspense fallback={null}>
            <Header {...props} />
        </React.Suspense>
    );
}
